<div class="card-container" *ngIf="canUseEprescriptionFeature">
  <frg-cards [border]="false" title="Recherche et Consultation d'E-Prescription">
    <div class="content-container" *ngIf="formGroup && formGroupDirect">
      <div class="direct-container">
        <form (ngSubmit)="consulterEprescriptions()">
          <div class="direct-infos-wrapper">
            <div class="direct-form-ligne">
              <frg-form-input id="uniqueId" type="text" label="Identifiant de la prescription*" [formGroup]="formGroupDirect"
                [control]="formGroupDirect.get('uniqueId')"></frg-form-input>
              <div class="form-buttons-wrapper">
                <div class="qr-code" title="Recherche une prescription avec un QR Code" (click)="openQrCodeReader()"></div>
              </div>
            </div>
            <div class="button-wrapper">
              <frg-button type="submit" [disabled]="formGroupDirect && !formGroupDirect.valid">Consulter directement</frg-button>
            </div>
          </div>
        </form>
      </div>
      <div class="search-container">
        <form (ngSubmit)="rechercherEprescriptions()">
          <div class="search-infos-wrapper">

            <div class="search-form-ligne">
              <frg-form-input id="typePrescription" type="ngSelect" label="Type de prescription" [formGroup]="formGroup" [required]="true"
                [control]="formGroup.get('typePrescription')" [selectValue]="typesPrescriptionAll"></frg-form-input>
              <frg-form-input id="soustypePrescription" type="ngSelect" label="Sous-type de prescription" [formGroup]="formGroup"
                [control]="formGroup.get('soustypePrescription')" [selectValue]="soustypesPrescription"></frg-form-input>
            </div>


            <div class="search-form-ligne">
              <frg-form-input id="datePrescriptionBorneBasse" type="date" label="Date prescription (borne basse)" [formGroup]="formGroup"
                [control]="formGroup.get('datePrescriptionBorneBasse')"></frg-form-input>
              <frg-form-input id="datePrescriptionBorneHaute" type="date" label="Date prescription (borne haute)" [formGroup]="formGroup"
                [control]="formGroup.get('datePrescriptionBorneHaute')"></frg-form-input>
            </div>

            <div class="search-form-ligne">
              <frg-form-input id="dateExecutionBorneBasse" type="date" label="Date d'exécution (borne basse)" [formGroup]="formGroup"
                [control]="formGroup.get('dateExecutionBorneBasse')"></frg-form-input>
              <frg-form-input id="dateExecutionBorneHaute" type="date" label="Date d'exécution (borne haute)" [formGroup]="formGroup"
                [control]="formGroup.get('dateExecutionBorneHaute')"></frg-form-input>
            </div>

            <div class="search-form-ligne">
              <frg-form-input id="dateModificationBorneBasse" type="date" label="Date de modification (borne basse)" [formGroup]="formGroup"
                [control]="formGroup.get('dateModificationBorneBasse')"></frg-form-input>
              <frg-form-input id="dateModificationBorneHaute" type="date" label="Date de modification (borne haute)" [formGroup]="formGroup"
                [control]="formGroup.get('dateModificationBorneHaute')"></frg-form-input>
            </div>

            <div class="search-form-ligne">
              <frg-form-input id="nirBenef" type="text" label="NIR du bénéficiaire" [formGroup]="formGroup"
                [control]="formGroup.get('nirBenef')"></frg-form-input>
            </div>

            <div class="search-form-ligne">
              <frg-form-input id="nirODDateNaissance" type="date" label="Date de naissance de l'ouvrant droit" [formGroup]="formGroup"
                [control]="formGroup.get('nirODDateNaissance')"></frg-form-input>
              <div style="flex-grow: 1;flex-shrink: 0;width: 50%;">&nbsp;</div>
            </div>

            <div class="search-form-ligne">
              <frg-form-input id="nirOD" type="text" label="NIR de l'ouvrant droit" [formGroup]="formGroup"
                [control]="formGroup.get('nirOD')"></frg-form-input>
              <frg-form-input id="nirODDateRang" type="number" label="Rang de l'ouvrant droit" [formGroup]="formGroup"
                [control]="formGroup.get('nirODDateRang')"></frg-form-input>
            </div>

          </div>
          <div class="error-form">
            <div *ngIf="formGroup.hasError('dateConflict')">
              Une seule des trois types de périodes peut être renseignée.
            </div>
            <div *ngIf="formGroup.hasError('dateRangeExceeded')">
              L'amplitude entre la date de début et la date de fin ne doit pas dépasser 60 jours.
            </div>
            <div *ngIf="formGroup.hasError('dateRangeIncomplete')">
              La date de début doit être présente si la date de fin est renseignée.
            </div>
          </div>
          <div class="button-wrapper">
            <frg-button type="submit" [disabled]="formGroup && !formGroup.valid">Rechercher</frg-button>
          </div>
        </form>
      </div>

      <div class="results-container" *ngIf="dataSource && dataSource.data && dataSource.data.length > 0">

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.prescriptionType}}</td>
          </ng-container>

          <ng-container matColumnDef="soustype">
            <th mat-header-cell *matHeaderCellDef> Sous-type </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.prescriptionSousType}}</td>
          </ng-container>

          <ng-container matColumnDef="numero">
            <th mat-header-cell *matHeaderCellDef> Numéro </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.prescriptionNumero}}</td>
          </ng-container>

          <ng-container matColumnDef="patientNirOD">
            <th mat-header-cell *matHeaderCellDef> NIR OD </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.patientNumNIROD}}</td>
          </ng-container>

          <ng-container matColumnDef="patientNir">
            <th mat-header-cell *matHeaderCellDef> NIR </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.patientNumNIR}}</td>
          </ng-container>

          <ng-container matColumnDef="patientDateNaissance">
            <th mat-header-cell *matHeaderCellDef> Date. Naiss </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.patientDateNai}}</td>
          </ng-container>

          <ng-container matColumnDef="patientRangNaissance">
            <th mat-header-cell *matHeaderCellDef> Rang. Naiss </th>
            <td mat-cell *matCellDef="let prescription" class="table-line">{{prescription.patientRang}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" appPreventDoubleClick (throttledClick)="displayPrescription(row);"></tr>

        </table>
      </div>
    </div>
  </frg-cards>
</div>
